// Gouvernance — Évaluations Policy (passées vs échouées).
import { PieChart, CheckCircle2, XCircle, Zap } from "lucide-react";
import { useGovernanceData } from "./useGovernanceFetch";

export default function GouvEvaluationsWidget() {
  const { data } = useGovernanceData();
  const evals = data.evaluations;

  return (
    <div className="p-5 rounded-xl bg-zinc-900/50 border border-zinc-800" data-testid="gouv-evaluations-widget">
      <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
        <PieChart className="w-5 h-5 text-emerald-400" />
        Évaluations règles métier
      </h3>
      {evals ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="p-3 rounded-lg bg-emerald-500/10 border border-emerald-500/20">
            <div className="flex items-center gap-2 mb-1">
              <CheckCircle2 className="w-4 h-4 text-emerald-400" />
              <span className="text-xs text-zinc-400">Passées</span>
            </div>
            <span className="text-2xl font-bold text-emerald-400">{evals.passed}</span>
          </div>
          <div className="p-3 rounded-lg bg-red-500/10 border border-red-500/20">
            <div className="flex items-center gap-2 mb-1">
              <XCircle className="w-4 h-4 text-red-400" />
              <span className="text-xs text-zinc-400">Échouées</span>
            </div>
            <span className="text-2xl font-bold text-red-400">{evals.failed}</span>
          </div>
        </div>
      ) : (
        <div className="text-center py-8 text-zinc-500">
          <Zap className="w-8 h-8 mx-auto mb-2 opacity-30" />
          <p className="text-sm">Aucune évaluation</p>
        </div>
      )}
    </div>
  );
}
